export const projects = [
  {
    img: "https://github.com/apoorv-14200/Pixelate2021-PathplanningBot/blob/main/media/sample.jpg?raw=true",
    name: "Autonomous Path Planning Bot",
    content:
      "It is computer vision based project which shows the application of data structutres and algorithms in real life. In this project we are taking image of grid which reresents city in which the colors of different cells represent the amount of traffic on that road.Now the problem is just to pick a patient from its location and drop him to respective hospital by taking shortest path.",
    link: "https://github.com/apoorv-14200/Pixelate2021-PathplanningBot",
  },
  {
    img: "https://github.com/apoorv-14200/HindiOCR/raw/main/whole%20process/myprocess.jpg",
    name: "Hindi-OCR",
    content:
      "Used image processing techniques to segment different characters in hindi word and recognized each character by training a custom ML model on Devnagri characters dataset with 21 classes giving 96% accuracy on training data and 95% on test data . Added features to handle rotated word,applied image processing for removing noise present in images.",
    link: "https://github.com/apoorv-14200/HindiOCR",
  },
  {
    img: "https://miro.medium.com/max/640/1*vzFwXFJOrg6WRGNsYYT6qg.png",
    name: "Assissitive Vision For Blind",
    content:
      "Used different ML concepts like NLP , CNN , LSTMS , WORD EMBEDDINGS to generate meaningful sentence to describe an image and converted to speech. Made a custom ML model using keras fuctional api and trained it on Flickr8k dataset. Made a web app using flask(locally hosted).",
    link: "https://github.com/apoorv-14200/Assistive-Vision-For-Blind",
  },
  {
    img: "http://socialengineindia.com/blog/wp-content/uploads/2019/01/social-networking-service.jpg",
    name: "Social Site API",
    content:
      "Created backend for a social site based on resful API'S.For database it uses mongodb ATLAS.For persistent user it uses jwt-token based signin.It has all the basic functionality such as making friends,creating post,like/comment on the post,editing profile",
    link: "https://github.com/apoorv-14200/Social-Site-Api",
  },
  {
    img: "https://miro.medium.com/max/1200/1*SwFB1o_k1LGprN-XRUZQ8w.jpeg",
    name: "E-commerce React Site",
    content:
      "Created Frontend of the site using React and backend in nodejs express API based.It has admin which can add the products,user can login/signup and can add products into cart",
    link: "https://github.com/apoorv-14200/eCommerce-React/tree/ApoorvJain",
  },
];
